import React from "react";

interface Props {
    children: React.ReactNode;
    menuOpen: boolean;
    subMenuOpen: boolean;
    setSubMenu: (value: boolean) => void;
}

export const DropDownNav = (props: Props) => {
    const { children, menuOpen, subMenuOpen, setSubMenu } = props;
    return (
        <button
            onClick={() => {
                setSubMenu(!subMenuOpen)
            }}
            id="learnMoreBtn"
            className={`flex  items-center p-3 justify-center w-full text-center ${menuOpen ? 'p-4' : ''
                }`}
        >
            {children}
            {subMenuOpen ? (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                    />
                </svg>
            ) : (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 9l6 6 6-6"
                    />
                </svg>

            )}
        </button>
    )
}